export const MAX_FILE_SIZE = 21474836480; // 20GB
export const ACCEPTED_TYPES = [
  "image/tiff"
];
export const MIN_DATE = new Date("October 8, 2009"); // Date of Maxar WorldView 2 launch
export const MAX_DATE = new Date();
export const DEFAULT_BRIGHTNESS = 0;
export const DEFAULT_CONTRAST = 0;
